/*** IMPORTS FROM imports-loader ***/
(function() {

define([
    'jquery',
    'pip-model',
    'utils.validate'
],
function(
    $,
    pip,
    thdValidate
){

	var obj = {
			init: function() {
				// keydown instead of keypress due to issue with delete in FF
				$(document).on('keydown', 'input.strictNumericValidation', function(e) {
					if ((e.ctrlKey || e.metaKey) && (e.which === 65 || e.which === 67 || e.which === 86 || e.which === 88)) {
						// CTRL||CMD && A,C,V,X; cut/copy/paste/select all
						return true;
					} else {
						// Enter||Backspace||Delete||Left arrow||Right arrow||Digit||Digit on number pad
						return e.which === 13 || e.which === 8 || e.which === 46 || e.which === 37 || e.which === 39 || /\d/.test(String.fromCharCode(e.which)) || /\d/.test(String.fromCharCode(e.which-48));
					}
				});
			},
			validateZipCode: function validateZipCode(zip) {
				var re5digit = /^\d{5}$/;
				if (zip && zip.length == 5 && re5digit.test(zip)) {
					return true;
				}
				return false;
			}
	};

	return $.extend(obj, thdValidate);

});

}.call(window));